export default __webpack_public_path__ + "static/media/avatar_cheshire_cat4.07a6e7d4.mp3";